import moment from "moment";
import { IGetPatientProfile } from "../../interfaces/i-patient-service";
import { formatDate } from "../vue-helpers/modifiers/value-modifier";

export function getPatientsProfileResponse(this: any, response: IGetPatientProfile) {
    if (response) {
        if (response.IsSuccessful) {
            this.patientDetails = response.data;
            if (this.patientDetails.CarePeriod) {
                [this.carePeriodStart, this.carePeriodEnd] = this.patientDetails.CarePeriod.split("-");
                this.carePeriodStart = formatDate(this.carePeriodStart);
                this.carePeriodEnd = formatDate(this.carePeriodEnd);
                const endDateYear = moment(this.carePeriodEnd).year();
                if (endDateYear == 9999) {
                    this.carePeriodEnd = "Open";
                } else {
                    this.carePeriodEnd = formatDate(this.carePeriodEnd);
                }
                this.carePeriod = this.carePeriodStart + " - " + this.carePeriodEnd;
            }
        } else {
            this.carePeriodEnd = "-";
            this.carePeriodStart = "-";
            this.carePeriod = "-";
            this._toastrService.error({
                title: `Error`,
                message: `There was a problem while loading the Patient Information. Please try again. If the problem persists, please report it.`
            });
        }
    }
}
